import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import * as freeSaucesActions from '../../state/modules/freeSauces/actions';
import { avaivableCountSelector } from '../../state/modules/freeSauces/selectors';

import DesktopView from './DesktopView';
import MobileView from './MobileView';

class FreeSaucesPanel extends Component {
  static defaultProps = {};

  static propTypes = {
    isPhone: PropTypes.bool,
    avaivableCount: PropTypes.number,
    hideFreeSaucesPanel: PropTypes.func,
  };

  componentWillReceiveProps({ avaivableCount }) {
    if (avaivableCount === 0 && avaivableCount !== this.props.avaivableCount) {
      this.props.hideFreeSaucesPanel();
    }
  }

  render() {
    const View = this.props.isPhone ? MobileView : DesktopView;

    return <View {...this.props} />;
  }
}

const connector = connect(
  state => ({
    ...state.freeSauces,
    avaivableCount: avaivableCountSelector(state),
    isPhone: state.responsive.isPhone,
  }),
  dispatch => bindActionCreators(freeSaucesActions, dispatch),
);

export default connector(FreeSaucesPanel);
